import React from 'react'

// import { sortBy } from 'lodash'

import './index.scss'

const AutoSuggest = props => {
  const [ value, setValue ] = React.useState(props.defaultValue || '')
  const [ options, setOptions ] = React.useState([])
  const [ optionsCache, setOptionsCache ] = React.useState([])
  const [ optionIndex, setOptionIndex ] = React.useState(-1)
  const [ selected, setSelected ] = React.useState({
    label: props.defaultValue,
    id: props.defaultValue,
  })
  const [ hasChanged, setHasChanged ] = React.useState(false)

  const ref = React.useRef(null)

  const getOptions = async term => {
    if(term.length > 0){
      const response = await fetch(`${props.fetchUrl}?${props.searchParam || 'term'}=${term.toLowerCase()}${props.maxResults ? `&limit=${props.maxResults}` : ''}`)
      const json = await response.json() || []

      // Update options schema.
      let _options = json[props.responseCollectionKey].map( option => {
        return {
          label: option[props.optionLabel],
          id: option[props.optionId],
        }
      })

      // if(term === '' && _options.length === 0){
      //   _options = props.defaultOptions || []
      // }

      setOptions(_options)
      setOptionsCache(_options)
    }
  }

  const handleBlur = e => {
    if(!e.relatedTarget || !e.relatedTarget.classList.contains('typeahead-option')){
      // Since we're allowing freeform text, just store it as the value.
      setSelected({
        label: value,
      })
      setOptions([])

      // // console.log('!e.relatedTarget')
      // if(!selected.id && !value) {
      //   // console.log('!selected.id && !value')
      //   if(options.length > 0){
      //     setValue(options[0].label)
      //     setSelected(options[0])
      //   } else {
      //     setValue('')
      //     setSelected({})
      //   }
      // } else if(!value){
      //   // console.log('!value')
      //   if(options.length > 0){
      //     setValue(options[0].label)
      //     setSelected(options[0])
      //   } else {
      //     setValue('')
      //     setSelected({})
      //   }
      // } else if(!selected.id && value){
      //   if(options.length > 0){
      //     setValue(options[0].label)
      //     setSelected(options[0])
      //     props.onSelect(options[0])
      //   } else {
      //     setValue('')
      //     setSelected({})
      //   }
      // }
      // setOptions([])
    }
  }

  const handleChange = e => {
    getOptions(e.target.value)
    setValue(e.target.value)
    setOptionIndex(-1)
    setHasChanged(true)
    setSelected({})
    props.onChange(e.target.value)
  }

  const handleKeyDown = React.useCallback( e => {
    if(e.keyCode === 13) { // 'User pressed enter key')
      // We want to fire an event that the delegate can handle.
      props.onEnter && props.onEnter()
    } else if(e.keyCode === 38) { // User pressed up arrow
      setOptionIndex( prevOptionIndex => options.length > 0 ? (prevOptionIndex - 1) < 0 ? options.length - 1 : prevOptionIndex - 1 : 0 )
    } else if(e.keyCode === 40) { // User pressed down arrow
      setOptionIndex( prevOptionIndex => options.length > 0 ? (prevOptionIndex + 1) > options.length - 1 ? 0 : prevOptionIndex + 1 : 0 )
    }
  }, [options])

  const handleOptionSelect = (e, option) => {
    if(e) {
      e.preventDefault()
      e.stopPropagation()
    }

    setValue(option.label)
    setSelected(option)
    setOptionIndex(options.map(option => option.label).indexOf(option.label))
    setOptions([])

    props.onSelect(option)
  }

  React.useEffect( () => {
    const element = ref.current

    element.addEventListener('keydown', handleKeyDown)
    return () => {
      element.removeEventListener('keydown', handleKeyDown)
    }
  }, [handleKeyDown])

  React.useEffect( () => {
    // This is for when the user uses arrows keys...
    if(options.length > 0 && optionIndex > -1){
      setValue(options[optionIndex].label)
      setSelected(options[optionIndex])
    }
  }, [optionIndex])

  React.useEffect( () => {
    // Update selected if necessary.
    if((!selected.label || selected.label !== value) && optionsCache.length){
      const _selected = optionsCache.filter( option => option.label === value )
      if(_selected.length) {
        setSelected( prevSelected => _selected[0] )
        props.onSelect(_selected[0])
      }
    }
  }, [value])

  React.useEffect( () => {
    props.onSelect(selected)
  }, [selected])

  return <div className="typeahead-container" ref={ref}>
    <input
      value={value || (!hasChanged && props.defaultValue ? props.defaultValue : '')}
      onChange={ e => handleChange(e)}
      placeholder={props.placeholder || 'Enter a value...'}
      onBlur={ e => handleBlur(e) }
      onClick={ e => {
        if(e.target.value?.trim().length === 0){
          if(props.defaultOptions){
            setOptions(props.defaultOptions)
          } else {
            handleChange(e)
          }
        }
      } }
      />
    {(options.length > 0) && <div className="typeahead-drop-container">
      {props.defaultOptionsLabel && !value && <label>{props.defaultOptionsLabel}</label>}
      {options.map( option => <a href="/" className="typeahead-option" key={option.id} onClick={ e => handleOptionSelect(e, option) } tabIndex="-1">{option.label}</a> )}
    </div>}
  </div>
}

export default AutoSuggest
